<nav id="admin" class="dash-nav navbar navbar-expand-md navbar-dark bg-admin">
    <div class="flex-row d-flex">
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#collapsingNavbar">
            <span class="navbar-toggler-icon"></span>
        </button>
        <a class="navbar-brand mr-0 text-dark" routerLink="/dashboard" title="">Fare Boutique</a>
    </div>
    <button class="navbar-toggler mr-0" type="button" data-toggle="collapse" data-target="#navbarContent"
                aria-controls="navbarContent" aria-expanded="false" aria-label="Toggle navigation">
             <i class="fa fa-bars"></i>
    </button>
    <div class="navbar-collapse collapse" id="collapsingNavbar">
        <ul class="navbar-nav ml-auto">
            <li class="nav-item">
                <a class="nav-link text-dark" href="#" data-toggle="collapse">Dashboard</a>
            </li>
            <li class="nav-item">
                <a class="nav-link text-dark" href="javascript:void(0)" (click)="logout()" >LogOut</a>
            </li>
        </ul>
    </div>
</nav>
